import { useEffect, useState } from "react";
import { BellRing, Check, Send, X } from "lucide-react";

export function FinaleNotifyModal({ onClose }) {
  const [form, setForm] = useState({ name: "", email: "", phone: "" });
  const [status, setStatus] = useState("idle");

  useEffect(() => {
    const onKeyDown = (event) => {
      if (event.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [onClose]);

  const updateField = (field, value) => setForm((current) => ({ ...current, [field]: value }));

  const submit = async (event) => {
    event.preventDefault();
    setStatus("sending");
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/finale-notify`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      if (!response.ok) throw new Error("save failed");
      setStatus("done");
    } catch {
      setStatus("error");
    }
  };

  return (
    <div className="ns-song-modal" role="dialog" aria-modal="true" aria-label="Finale reminder signup" data-testid="finale-notify-modal" onClick={onClose}>
      <div className="ns-notify-card" onClick={(event) => event.stopPropagation()}>
        <div className="ns-song-modal-head">
          <p><BellRing size={14} /> Season 1 Finale Reminder</p>
          <button type="button" data-testid="finale-notify-close" aria-label="Close reminder signup" onClick={onClose}><X size={18} /></button>
        </div>
        {status === "done" ? (
          <div className="ns-notify-success" data-testid="finale-notify-success">
            <span className="ns-notify-check"><Check size={22} /></span>
            <h2>You&rsquo;re on the list!</h2>
            <p>We&rsquo;ll whisper to your inbox the moment Episode 15 · The Great Magical Call arrives.</p>
            <button type="button" className="ns-season-watch" data-testid="finale-notify-done" onClick={onClose}>Back to the magic</button>
          </div>
        ) : (
          <form className="ns-notify-form" data-testid="finale-notify-form" onSubmit={submit}>
            <p>Leave your email and we&rsquo;ll tell you the instant the Season 1 finale drops.</p>
            <input type="text" data-testid="finale-name-input" placeholder="Your name (optional)" value={form.name} onChange={(event) => updateField("name", event.target.value)} maxLength={100} />
            <input type="email" data-testid="finale-email-input" placeholder="your@email.com" value={form.email} onChange={(event) => updateField("email", event.target.value)} required />
            <input type="tel" data-testid="finale-phone-input" placeholder="Contact number (optional)" value={form.phone} onChange={(event) => updateField("phone", event.target.value)} maxLength={20} />
            {status === "error" && <p className="ns-notify-error" data-testid="finale-notify-error">We could not save your reminder just now. Please try again.</p>}
            <button type="submit" className="ns-season-watch" data-testid="finale-notify-submit" disabled={status === "sending"}>{status === "sending" ? "Saving…" : <>Remind me <Send size={14} /></>}</button>
          </form>
        )}
      </div>
    </div>
  );
}
